import { bff } from '../../env'
import { BffErrorResponse } from '../api/types'

const endpoint = `${bff}/crm/leads`
const flexibleLeadEndpoint = `${bff}/crm/leads/flex`

export type LeadRequest = {
  email: string
  firstName: string
  lastName: string
  phoneNumber?: string
  companyName?: string
  marketingConsent?: boolean
  submissionType?: string
  utmSource?: string
  utmCampaign?: string
  utmMedium?: string
  utmContent?: string
  utmTerm?: string
  locationId?: string
  locationName?: string
  websiteMarket?: string
  /** Semicolon separated values, if multiple */
  inquiryProductType?: string
  additionalInfo?: string
  productId?: string
  productName?: string
  productCapacity?: number
  /** Format: "YYYY-MM-DD HH:mm:ss". Don't use ISO 8601 */
  startDate?: string
  /** Format: "YYYY-MM-DD HH:mm:ss". Don't use ISO 8601 */
  endDate?: string
  bookingSource?: string
  googleAnalyticsClientId?: string
}

export type LeadResponse = {
  id: string
  properties: Record<
    | 'createdate'
    | 'email'
    | 'firstname'
    | 'hs_all_contact_vids'
    | 'hs_email_domain'
    | 'hs_is_contact'
    | 'hs_is_unworked'
    | 'hs_lifecyclestage_lead_date'
    | 'hs_marketable_until_renewal'
    | 'hs_object_id'
    | 'hs_pipeline'
    | 'lastmodifieddate'
    | 'lastname'
    | 'lifecyclestage',
    string
  >
  createdAt: string
  updatedAt: string
  archived: boolean
}

export type LeadErrorResponse = {
  error: string[]
}

export const createLead = async (body: LeadRequest): Promise<LeadResponse | BffErrorResponse> => {
  const response = await fetch(endpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  return response.json()
}

export const createFlexibleLead = async (
  body: Record<string, string | number | boolean>
): Promise<LeadResponse | BffErrorResponse> => {
  const response = await fetch(flexibleLeadEndpoint, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(body),
  })

  if (!response.ok) {
    throw await response.json()
  }

  return response.json()
}
